import React from 'react';
import EmpKPIEntry from './Sup_KPI_Update';
import '../../../CommonCSS/SocietyCSS.css'

const Emp_KPI_EntryApp = () => {
  return (

    <div className="app-wrapper">
      <div className="form-container">
        <div className='card' style={{borderRadius: '8px'}}>
          <div className="card-header-css" style={{borderRadius: '8px', textAlign: 'center' }} >
            <h5>Supervisor KPI Review/Update</h5>
          </div>
        </div>
        <EmpKPIEntry/>
      </div>
    </div >
  );
};

export default Emp_KPI_EntryApp;
